import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { db } from "../../firebase/config";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";

const CompletarPerfil = () => {
  const { user } = useAuth();
  const email = user?.email?.toLowerCase();

    const [form, setForm] = useState({
      nombres: "",
      apellidos: "",
      rut: "",
      celular: "+569",
      t_emergencia: "",
    });


    const handleChange = (e) => {
      const { name, value } = e.target;
      setForm((prev) => ({ ...prev, [name]: value }));
    };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.nombres ||
      !form.apellidos ||
      !form.rut ||
      !form.celular
    ) {
      alert("Por favor completa los campos obligatorios.");
      return;
    }

    try {
      await updateDoc(doc(db, "usuarios", email), {
        nombres: form.nombres.trim(),
        apellidos: form.apellidos.trim(),
        rut: form.rut.trim(),
        celular: form.celular.trim(),
        t_emergencia: form.t_emergencia?.trim() || "",
        actualizadoEn: serverTimestamp(),
      });

      window.location.href = "/paciente/perfil";
    } catch (error) {
      console.error("Error guardando perfil:", error);
      alert("No se pudo guardar la información.");
    }
  };


  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{
        background: "linear-gradient(to bottom right, #EAF6FF, #DCEFFF, #F8FAFC)",
      }}
    >
      <div className="w-full max-w-3xl rounded-3xl bg-white/60 backdrop-blur-xl shadow-[0_18px_50px_-10px_rgba(58,106,255,0.25)] ring-1 ring-white/30 p-8">
        
        <h1 className="text-2xl md:text-3xl font-extrabold text-center text-[#0A1440] mb-8">
          Completa tu perfil para continuar
        </h1>

        <form onSubmit={handleSubmit} className="space-y-5">

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

            {/* Nombre */}
            <div>
              <label className="text-sm font-medium text-[#0A1440] mb-1 block">
                Nombres <span className="text-red-500">*</span>
              </label>
              <input
                name="nombres"
                value={form.nombres}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-white/90 border border-blue-100 
                focus:ring-2 focus:ring-[#3A6AFF]"
              />
            </div>

            {/* Apellido */}
            <div>
              <label className="text-sm font-medium text-[#0A1440] mb-1 block">
                Apellidos <span className="text-red-500">*</span>
              </label>
              <input
                name="apellidos"
                value={form.apellidos}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-white/90 border border-blue-100 
                focus:ring-2 focus:ring-[#3A6AFF]"
              />
            </div>

            {/* RUT */}
            <div>
              <label className="text-sm font-medium text-[#0A1440] mb-1 block">
                RUT <span className="text-red-500">*</span>
              </label>
              <input
                name="rut"
                placeholder="12345678-9"
                value={form.rut}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-white/90 border border-blue-100 
                focus:ring-2 focus:ring-[#3A6AFF]"
              />
            </div>

            {/* Teléfono */}
            <div>
              <label className="text-sm font-medium text-[#0A1440] mb-1 block">
                Teléfono <span className="text-red-500">*</span>
              </label>
              <input
                name="celular"
                value={form.celular}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-white/90 border border-blue-100 
                focus:ring-2 focus:ring-[#3A6AFF]"
              />
            </div>

            {/* Teléfono de emergencia (opcional) */}
              <div>
                <label className="text-sm font-medium text-[#0A1440] mb-1 block">
                  Teléfono de emergencia
                </label>
                <input
                  name="t_emergencia"
                  value={form.t_emergencia}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-xl bg-white/90 border border-blue-100 
                  focus:ring-2 focus:ring-[#3A6AFF]"
                />
              </div>
          </div>

          {/* Botón */}
          <button
            type="submit"
            className="w-full py-3 mt-4 rounded-xl bg-[#3A6AFF] text-white font-semibold hover:bg-blue-700 transition"
          >
            Guardar y continuar
          </button>

        </form>
      </div>
    </div>
  );
};

export default CompletarPerfil;
